import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CoreModule } from 'app/modules/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PositionService } from '@services/position.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampusService } from '@services/campus.service';
import { FormBuilder } from '@angular/forms';
import { EntityService } from '@services/entity.service';
import { CampusTypeService } from '@services/campusType.service';

@Component({
  selector: 'app-capitals',
  standalone: true,
  imports: [NgSelectModule, CoreModule],
  providers: [ PositionService, EntityService, CampusTypeService],
  templateUrl: './capitals.component.html',
  styleUrls: ['./capitals.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CapitalsComponent implements OnInit {

  private _positionService = inject(PositionService)
  private _entityService = inject(EntityService)
  private _campusTypeService = inject(CampusTypeService)
  private _fb = inject(FormBuilder)
  private modalService = inject(NgbModal)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected listPeriods: any[] = []
  protected listTypesCampus: any = []
  protected listPositions: any = []
  protected positionSelected: any = null
  private today = new Date()
  public modalOptions = {
    size: 'lg',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public closeResult = ""

  protected newPositionForm = this._fb.group({
    _id: [null],
    typeCampusId: [null],
    name: [null],
    fmr: [null],
    pesos: [null],
    totalUF: [null],
    year: [null],
    enabled: [true]
  })


  ngOnInit(): void {
    this.getYears()
  }

  getPositions() {
    this._positionService.getByType(this.newPositionForm.value.typeCampusId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listPositions = res
      this.cdr.markForCheck()
    })
  }


  getTypesCampus() {
    this._campusTypeService.getByYear(this.newPositionForm.value.year).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listTypesCampus = res
      this.newPositionForm.patchValue({ typeCampusId: res[0]._id })
      this.getPositions()
      this.cdr.markForCheck()
    })
  }

  getYears() {
    const initialYear = this.today.getFullYear() - 1;
    const currentYear = this.today.getFullYear() - 1;
    const currentMonth = this.today.getMonth() + 1;

    let endYear = currentYear;
    if (currentMonth > 6) {
      endYear += 1;
    }
    
    for (let year = initialYear; year <= endYear; year++) {
      this.listPeriods.push(year);
    }

    this.newPositionForm.patchValue({ year: this.listPeriods[0] })
    this.getTypesCampus()
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  savePosition() {
    if (this.newPositionForm.value._id) {
      this._positionService.updatePosition(this.newPositionForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        this.getPositions()
      })
    } else {
      this._positionService.createPosition(this.newPositionForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        this.getPositions()
      })
    }
  }

  openEditModal(content: any, position: any) {
    this.newPositionForm.patchValue(position)
    this.open(content)
  }
}
